import ReactMarkdown from "react-markdown";

interface JobDetailsProps {
  description: string;
  requirements: string[];
  benefits: string[];
  getRequirementLabel: (req: string) => string;
  getBenefitLabel: (benefit: string) => string;
  requirementsLabel: string;
  benefitsLabel: string;
}

export function JobDetails({
  description,
  requirements,
  benefits,
  getRequirementLabel,
  getBenefitLabel,
  requirementsLabel,
  benefitsLabel
}: JobDetailsProps) {
  return (
    <>
      <div className="text-gray-700 mb-6 space-y-4 [&>ul]:list-disc [&>ul]:pl-5 [&>ol]:list-decimal [&>ol]:pl-5 [&>h1]:text-xl [&>h1]:font-semibold [&>h2]:text-lg [&>h2]:font-semibold [&>h3]:text-base [&>h3]:font-semibold">
        <ReactMarkdown>{description}</ReactMarkdown>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div>
          <h4 className="font-medium text-gray-900 mb-2">
            {requirementsLabel}
          </h4>
          <ul className="text-sm text-gray-600 space-y-1">
            {requirements.map((req, index) => (
              <li key={index}>• {getRequirementLabel(req)}</li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-medium text-gray-900 mb-2">{benefitsLabel}</h4>
          <ul className="text-sm text-gray-600 space-y-1">
            {benefits.map((benefit, index) => (
              <li key={index}>• {getBenefitLabel(benefit)}</li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
